import React, { useState, useEffect } from "react";

import "./kicker.css";
import kick from "../../assets/kickfoot.png";
import baby from "../../assets/babyst.png";
import right from "../../assets/right.png";
import left from "../../assets/left.png";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

function KickerChart() {
  const [kickData, setKickData] = useState({
    startTime: "",
    endTime: "",
    totalKicks: 0,
  });

  const location = useLocation();

  useEffect(() => {
    let latestKickData = {
      startTime: "",
      endTime: "",
      totalKicks: 0,
    };

    if (location.state) {
      latestKickData = {
        startTime: location.state.startTime,
        endTime: location.state.endTime,
        totalKicks: location.state.totalKicks,
      };
    } else {
      const kickDataArray =
        JSON.parse(localStorage.getItem("kickDataArray")) || [];
      if (kickDataArray.length > 0) {
        latestKickData = kickDataArray[kickDataArray.length - 1];
      }
     
      
    }

    setKickData(latestKickData);
  }, [location]);

  const [count, setCount] = useState(18);

  return (
    <>
      <Helmet>
        <title>Baby Kicker</title>
      </Helmet>
      <div style={{ backgroundColor: "#DEDEDE" }} className="kicker-base">
        <div style={{ backgroundColor: "white" }} className="main-kick">
          <div className="kicker-container">
            <a href="/">
              <button id="left-btn">
                <img
                  src={left}
                  className="right-ar"
                  style={{
                    animation: "bouncer 1s infinite",
                    marginRight: "20px",
                    marginTop: "-4px",
                  }}
                />
                Track Your Pregnancy
              </button>
            </a>
            <a href="/">
              <button id="right-btn">
                Contraction Timer
                <img
                  src={right}
                  className="right-ar"
                  style={{
                    animation: "bouncer 1s infinite",
                    marginLeft: "20px",
                    marginTop: "-4px",
                  }}
                />
              </button>
            </a>
          </div>
          <div className="ad-content-ad">
            <div className="ad1">
              <h1>AD</h1>
            </div>
            <div className="main-cont">
              <h2 style={{ color: "#B24C76", textAlign: "center" }}>
                Baby Kick Timer
              </h2>
              <p style={{ textAlign: "center" }}>
                The Kicks, rolls/wiggles will evolve throughout your pregnancy
                and with the Kick timer you are able to record the number of
                kicks.
              </p>
              <p style={{ textAlign: "center" }}>
                Counting 10 movements of any kind in one to two hours tends to
                be the norm, though sometimes it can take longer.
              </p>

              <img src={baby} alt="Trigger" className="baby-butterfly" />

              <h4 style={{ color: "#B24C76", marginTop: "20px" }}>
                {" "}
                You are at week {count}
              </h4>
              <p>
                You may feel like Butterflies fluttering in your belly at this
                stage
              </p>

              {/* Chart for current One........................................... */}
              <div className="chart-tablee">
                <h2 style={{ textAlign: "center", marginTop: "20px" }}>
                  The Little One's Previous Time Kicks
                </h2>
                <table className="kick-table">
                  <thead>
                    <tr>
                      <th>Kicks Started at</th>
                      <th>Ended at</th>
                      <th>Number of Kicks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{kickData.startTime || "__"}</td>
                      <td>{kickData.endTime || "__"}</td>
                      <td>{kickData.totalKicks || 0}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <Link to="/kicker/show">
                <button
                  id="time3"
                  style={{ background: "#B24C76", color: "white" }}
                >
                  Start Counting Kicks
                </button>
              </Link>
            </div>
            <div className="ad2">
              <h1>AD</h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default KickerChart;
